import BaseModel from "./base.model";

export default class BankDetailsModel extends BaseModel {

  bank = null;
  bank_name = null;
  bank_display_name = null;
  account_number = null;
  account_name = null;
  account_type = null;
  branch_code = null;

  constructor (data) {
    super();
    if (this.isEmpty(data)) return this;
    this.bank = data.bank;
    this.bank_name = data.bank_name;
    this.bank_display_name = data.bank_display_name;
    this.account_number = data.account_number;
    this.account_name = data.account_name;
    this.account_type = data.account_type;
    this.branch_code = data.branch_code;
  }

  validateBankDetails() {
    return !this.isEmpty(this.bank) &&
      !this.isEmpty(this.account_number) &&
      !this.isEmpty(this.account_name) &&
      !this.isEmpty(this.account_type) &&
      !this.isEmpty(this.branch_code)
  }
}
